import { BodyCopy, Meta } from '@xing-com/typography';

import * as Styled from './single-select.styles';
import type { SingleSelectProps } from './single-select.types';

export const SingleSelect = ({
  children,
  selected,
  description,
  ...props
}: SingleSelectProps): JSX.Element => (
  <Styled.SingleSelect
    description={description}
    data-xds="SingleSelect"
    $selected={selected}
    {...props}
  >
    {description ? (
      <Styled.SingleSelectContentContainer>
        <BodyCopy noMargin size="medium">
          {children}
        </BodyCopy>
        <Meta noMargin size="xsmall">
          {description}
        </Meta>
      </Styled.SingleSelectContentContainer>
    ) : (
      children
    )}
  </Styled.SingleSelect>
);
